/** @jsxImportSource @emotion/react */
import moment from "moment";
import { TableRow } from "../../../../components/table-components/TableRow";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { colors } from "../../../../components/colors";
import { InLineLabel } from "../../../../components/Label";
import { StyledText } from "../../../../assets/typography/typography";
import { HomepageConfigListItem } from "../../model/HomepageConfigListSuccessResponse";
import { routes } from "../../../../appRoutingHelpers";
import { formatDateWithYearAndTime } from "../../../../util";
import { firstTableCellStyle } from "../../../../style-util";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { Avatar } from "../../../../components/Avatar";

type Props = {
  homepage: HomepageConfigListItem;
};

export const AppHomepageListRow = ({ homepage }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const homepageIsActive = (
    activeFrom: string | null,
    activeTo: string | null
  ) => {
    if (!activeTo || !activeFrom) {
      return true;
    }
    return (
      moment(activeTo).isAfter(moment()) &&
      moment(activeFrom).isBefore(moment())
    );
  };
  const href = routes.homepageUpsertListEdit(organizationKeyName, homepage.id!);

  const isActive = homepageIsActive(homepage.validFrom, homepage.validTo);

  return (
    <TableRow>
      <TableCellLink href={href} css={firstTableCellStyle}>
        <Avatar imageUrl={homepage.imageUrl}>
          {homepage.name.charAt(0).toUpperCase()}
        </Avatar>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {homepage.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <InLineLabel
          backgroundColor={isActive ? colors.successLight : colors.errorLight}
          color={isActive ? colors.successDark : colors.errorDark}
        >
          {isActive ? "Visible" : "Not visible"}
        </InLineLabel>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {homepage.validFrom
            ? formatDateWithYearAndTime(homepage.validFrom)
            : "-"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {homepage.validTo ? formatDateWithYearAndTime(homepage.validTo) : "-"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {homepage.announcementsItems
            ? homepage.announcementsItems.length
            : "0"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {homepage.vouchers ? homepage.vouchers.length : "0"}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};
